/**
 * The display fallback for a backend vocabulary value this build has never
 * seen: the served slug in words ("chainlink_feed" reads "Chainlink feed"),
 * never the raw value.
 */
export function humanizeSlug(value: string): string {
  const words = value.replaceAll(/[_-]+/g, ' ').trim();
  return words.replace(/^./, (first) => first.toUpperCase());
}
